import { RolesService } from "@/common/api.service"
import { FETCH_ROLES, RESET_STATE } from "./actions.type"
import { SET_ROLES, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        roles: [],
    }
}

let state = initialState()

const getters = {
    roles(state) {
        return state.roles
    }
}

const actions = {
    async [FETCH_ROLES](context, slug) {
        const { data } = await RolesService.get(slug)
        context.commit(SET_ROLES, data.data)
        return data;
    },
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET)
    }
}

const mutations = {
    [SET_ROLES](state, rolesdata) {
        state.roles = rolesdata
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};